import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from "@mui/material";
import {
  CheckCircle as CheckIcon,
  Close as CloseIcon,
  GitHub as GitHubIcon,
} from "@mui/icons-material";

const SuccessPopup = ({
  open,
  handleClose,
  projectName,
  projectDetails,
  onDownload,
  onPushToGitHub,
  isDownloading,
}) => {
  // Function to navigate to the test automation dashboard
  const handleNavigate = () => {};
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            width: {
              xs: "90vw", // Mobile
              sm: "70vw", // Tablet
              md: "50vw", // Small laptops
              lg: "40vw", // Desktop
            },
            maxWidth: "600px",
          },
        },
      }}
    >
      <Box
        sx={{
          p: { xs: 2, sm: 3 },
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {/* Header with close button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontSize: "24px",
              fontFamily: "Manrope",
              color: "#333",
            }}
          >
            Your {projectName || ""} Project is Successfully Generated!
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{
              color: "#666",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {/* Success Icon and Message */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <CheckIcon
              sx={{
                color: "#4caf50",
                fontSize: "48px",
                mr: 2,
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                fontFamily: "Manrope",
                color: "#333",
                lineHeight: 1.5,
              }}
            >
              You may now proceed to tweak the script in your system's download
              folder and execute.
            </Typography>
          </Box>

          {/* Project Details */}
          {!!projectDetails && (
            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                padding: "16px",
                mb: 3,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: "18px",
                  fontFamily: "Manrope",
                  fontWeight: 600,
                  color: "#333",
                  mb: 1,
                }}
              >
                Project Details
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontFamily: "Manrope",
                  color: "#666",
                  lineHeight: 1.4,
                }}
              >
                {Object.entries(projectDetails).map(([key, value]) => (
                  <span>
                    • {key}: {value}
                    <br />
                  </span>
                ))}
              </Typography>
            </Box>
          )}
        </Box>

        {/* Divider */}
        <Divider sx={{ my: 2 }} />

        {/* Action Buttons */}
        <Box
          sx={{ display: "flex", gap: 2, justifyContent: "flex-end", pt: 2 }}
        >
          {/* OK Button */}
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              borderColor: "#0094FB",
              color: "#0094FB",
              textTransform: "none",
              fontWeight: 500,
              borderRadius: "8px",
              //   fontFamily: "Manrope",
              //   padding: "10px 24px",
              //   minWidth: "100px",
              "&:hover": {
                borderColor: "#0094FB",
                backgroundColor: "rgba(0, 148, 251, 0.04)",
              },
            }}
          >
            OK
          </Button>

          {/* Download Project Button */}
          <Button
            onClick={onDownload}
            disabled={isDownloading}
            variant="contained"
            startIcon={<CheckIcon />}
            sx={{
              backgroundColor: "#0094FB",
              color: "white",
              textTransform: "none",
              fontWeight: 500,
              borderRadius: "8px",
              //   fontFamily: "Manrope",
              //   padding: "10px 24px",
              //   minWidth: "160px",
              "&:hover": {
                backgroundColor: "#0078D4",
              },
              "&:disabled": {
                backgroundColor: "#ccc",
                color: "#666",
              },
            }}
          >
            {isDownloading ? "Downloading..." : "Download Project"}
          </Button>

          {/* Push to GitHub Button */}
          <Button
            onClick={onPushToGitHub}
            variant="contained"
            endIcon={<GitHubIcon />}
            sx={{
              backgroundColor: "#24292e",
              color: "white",
              textTransform: "none",
              fontWeight: 500,
              borderRadius: "8px",
              //   fontFamily: "Manrope",
              //   padding: "10px 24px",
              //   minWidth: "160px",
              "&:hover": {
                backgroundColor: "#1a1e22",
              },
            }}
          >
            Push to GitHub →
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SuccessPopup;
